import React, { useState, useEffect } from 'react';
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import CitasPendientesData from '../../Components/Admin/CitasPendientes/CitasPendientesMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import Grafico1 from '../../Components/Admin/Graficos/Grafico1'
import Grafico2 from '../../Components/Admin/Graficos/Grafico2'
import { fetchUsuario, getUsuario } from '../../Components/user';
import TurnosData from '../../Components/Admin/TerapeutaCitas/Citas'
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';

export default function Main() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />

                {loading ? (
                    < ></>
                ) : usuarioLegued?.idUsuario ? (
                    <>
                        {puedeVerMenu(usuarioLegued.rol, 'dashboard') ? (
                            <>
                                <div className='containerMain'>
                                    <div className='deFLexMain'>
                                        <CardsCantidad />
                                        <CitasPendientesData />
                                    </div>
                                    <div className='graficosFlex'>
                                        <Grafico1 />
                                        <Grafico2 />
                                    </div>
                                </div>
                            </>
                        ) : usuarioLegued?.rol === 'terapeuta' ? (
                            <>
                                <div className='container2'>
                                    <TurnosData />
                                </div>

                            </>
                        ) : (
                            <div>
                                <SinPermisos />
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className='containerMain'>
                            <div className='deFLexMain'>
                                <CardsCantidad />
                                <CitasPendientesData />
                            </div>
                            <div className='graficosFlex'>
                                <Grafico1 />
                                <Grafico2 />
                            </div>
                        </div>
                    </>
                )}
                <div>

                </div>
            </section>
        </div>
    )
}
